<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{title}}
          </h3>
          <DeviseAddModal v-on:deviseadded="reloadData" ></DeviseAddModal>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <transition name="fade">
        <div  v-if="ImpossibleAddDevise" 
              class="alert alert-danger" 
              role="alert">
          Impossible de supprimer cette devise
        </div>
      </transition>
      <div class="col-lg-3 float-right">
        <base-input alternative=""
                    placeholder="Rechercher"
                    input-classes="form-control-alternative input_search"
                    v-model="search"
                    @change="searchData"
        />
      </div>
      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="data"
                  :columns="columns"
                  :sortKey.sync="sortKey"
                  :reverse.sync="reverse"
                  @KeyChanged="reloadDataSorted"
                  @reverse="reverseChange"
                  @sortKey="sortKeyChange">
        <template slot="columns">
        </template>

        <template slot-scope="{row}">
          <td>
            {{row.idDevise}}
          </td>
          <td>
            {{row.nom}}
          </td>
          <td>
            {{row.symbole}}
          </td>
          <td>
            <div class="row">
              <DeviseEditModal v-bind:devise="row"></DeviseEditModal>&nbsp;&nbsp;&nbsp;
              <a @click.prevent="deleteDevise($event, row.idDevise)" href="#"><i class="fa fa-trash-alt"></i></a>
            </div>
          </td>
        </template>

      </base-table>
    </div>

    <div class="card-footer d-flex justify-content-end"
         :class="type === 'dark' ? 'bg-transparent': ''">
        <base-pagination 
            :total="total"
            :perPage="perPage"
            @input="changeData"
            ></base-pagination>
    </div>

  </div>
</template>
<script>
  import constvar from '@/const'
  import _ from 'lodash'
  import router from '@/router'
  import DeviseAddModal from '@/components/DeviseAddModal'
  import DeviseEditModal from '@/components/DeviseEditModal'

  export default {
    name: 'fournisseur-table',
    components: {
      DeviseAddModal,
      DeviseEditModal
    },
    props: {
      type: {
        type: String
      },
      title: String
    },
    data() {
      return { 
        total: 0,
        alldata: [],
        data: [],
        perPage: 10,
        value: 1,
        sortKey: 'idDevise',
        reverse: true,
        search: '',
        columns: [
          ['idDevise','ID'],
          ['nom','Nom'],
          ['symbome','Symbole'],
          ['','']
          ],
        ImpossibleAddDevise: false,
      }
    },
    computed: {
      alldata_filtered: function() { 
        if(this.search != '') {
          return this.alldata.filter(({idDevise, nom, symbole}) => idDevise == this.search || nom.toLowerCase().includes(this.search.toLowerCase()) || symbole.toLowerCase().includes(this.search.toLowerCase()));
        } else {
          return this.alldata;
        }
      }
    },
    async created() {
        const response = await fetch(constvar.api_url+'devise', {
        method: 'GET',
        credentials: 'include',
        });
        if(response.ok) { 
            const json = await response.json();
            //check if api return regenerated token
            if(json.code != 409) {
                this.alldata = json;
                this.changeData(1);
                this.total = this.alldata_filtered.length;
            } else { 
                router.push("login")    
            }
        }
    },
    methods: {
        sortTableData: function() {
          this.alldata.forEach(function(element) {
            element.idDevise = Number(element.idDevise);
          })
          return _.orderBy(this.alldata_filtered, this.sortKey, (this.reverse) ? 'desc' : 'asc')
        },
        changeData: function(e) {
            let page = e;
            let perPage = this.perPage;
            let from = (page * perPage) - perPage;
            let to = (page * perPage);
            let tableData = this.sortTableData();
            this.data = tableData.slice(from, to);
            this.value = page;
        },
        reloadDataSorted: function() {
          this.changeData(this.value);
        },
        sortKeyChange: function(e) {
          this.sortKey = e;
        },
        reverseChange: function(e) {
          this.reverse = e;
        },
        searchData: function() {
        },
        reloadData: async function() {
          const response = await fetch(constvar.api_url+'devise', {
          method: 'GET',
          credentials: 'include',
          });
          if(response.ok) { 
              const json = await response.json();
              //check if api return regenerated token
              if(json.code != 409) {
                  this.alldata = json;
                  this.changeData(1)
                  this.total = this.data.length;
              } else { 
                  router.push("login")    
              }
          } 
        },
        deleteDevise: async function(event, idDevise) {
          var self = this;
          let options = {
              okText: 'Confirmer',
              cancelText: 'Annuler',
          };
          this.$dialog
          .confirm('Êtes vous sûr de vouloir supprimer cette devise ?', options)
          .then(async function() {
            const response = await fetch(constvar.api_url+'devise/'+idDevise, {
            method: 'DELETE',
            credentials: 'include',
            });
            if(response.ok) { 
                const json = await response.json();
                //check if api return regenerated token
                if(json.rows == 1) {
                    self.reloadData();
                } else if(json.rows == -1) {
                    self.ImpossibleAddDevise = true
                    setTimeout(()=>{
                      self.ImpossibleAddDevise = false
                    },1500);
                } else { 
                    router.push("login")    
                }
            } 
          })
        },
    },
    watch: {
      alldata_filtered: function() {
        this.changeData(this.value);
      }
    },
  }
</script>
<style>
</style>
